import { StepSelector } from "./StepSelector";

export const jobStepsSelector = {
  sidebar: new StepSelector("job-sidebar"),
  searchJobs: new StepSelector("search-jobs"),
  filterJobs: new StepSelector("filter-jobs"),
  newJob: new StepSelector("new-job"),
  jobItem: new StepSelector("job-item"),
  navigationJobs: new StepSelector("navigation-jobs"),
  jobDetail: new StepSelector("job-detail"),
};
